import { stringLength } from "@firebase/util";

const firebase = require("../firebase/config.js"); // Firebase Config
// const Console = console

export default {
  Test: function() {
    return new Promise(resolve => {
      resolve(console.log("Testing"));
    });
  },
  CreateDocument: function(collection, data, id) {
    return new Promise(resolve => {
      let Document = firebase.db.collection(collection);
      if (id === undefined) {
        Document.add(data)
          .then(docRef => {
            resolve({
              result: "success",
              message: "Document Successfuly Written",
              id: docRef.id
            });
          })
          .catch(error => {
            resolve({
              result: "error1",
              message: error,
              id: ""
            });
          });
      } else {
        Document.doc(id)
          .set(data)
          .then(() => {
            resolve({
              result: "success",
              message: "Document Successfuly Written",
              id: id
            });
          })
          .catch(error => {
            resolve({
              result: "error2",
              message: error,
              id: ""
            });
          });
      }
    });
  },
  // Read Documents
  ReadDocuments: function(collection, portalID, userID) {
    return new Promise(resolve => {
      let Documents = firebase.db.collection(collection);
      // Filter Documents for a specific userID - Not Mandatory
      if (userID !== null && userID !== undefined) {
        Documents.where("userID", "==", userID);
      }
      let Data = [];
      if (portalID !== undefined) {
        Documents.where("portalID", "array-contains", portalID)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              var Document = {};
              Document = doc.data();
              Document.id = doc.id;
              Data.push(Document);
            });
            resolve({
              result: "success",
              message: "Found " + Data.length + " Documents",
              data: Data
            });
          })
          .catch(function(error) {
            // console.log("Error getting documents: ", error);
            resolve(error);
          });
      } else {
        resolve({
          result: "failure",
          message: "Missing portalID",
          data: Data
        });
      }
    });
  },
  UpdateDocument: function(collection, id, data) {
    return new Promise((resolve, reject) => {
      let Document = firebase.db.collection(collection).doc(id);
      Document.set(data, { merge: true })
        .then(() => {
          resolve({
            result: "success",
            message: "Document Updated",
            id: id
          });
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  UpdateDocumentsFields: function(collection, id, value) {
    return new Promise((resolve, reject) => {
      let Document = firebase.db.collection(collection).get();
      Document.then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          let UpdateField = firebase.db.collection(collection).doc(id);
          return UpdateField.update({
            status: value
          });
        });
      }).catch(error => {
        reject(error);
      });
    });
  },
  DeleteDocument: function(collection, id) {
    return new Promise(resolve => {
      collection = collection.toString();
      id = id.toString();
      console.log("collection=" + collection);
      console.log("id=" + id);
      let Document = firebase.db.collection(collection).doc(id);
      Document.delete()
        .then(() => {
          resolve({
            result: "success",
            message: "Document Deleted",
            id: id
          });
        })
        .catch(error => {
          resolve({
            result: "error",
            message: error,
            id: ""
          });
        });
    });
  },

  UpdateDocumentByDate: function(
    collection,
    data,
    resourcedate,
    resourceslots
  ) {
    return new Promise((resolve, reject) => {
      let Document = firebase.db.collection(collection).doc(resourcedate);
      // // console.log("data=" + JSON.stringify(data, null, 2));
      Document.get().then(function(doc) {
        if (doc.exists) {
          let DBSchedule = doc.data();
          // Document Found
          var Conflict = [];
          for (var i = 0; i < resourceslots.length; i++) {
            /*
            // console.log(
              "Slot data = " +
                DBSchedule[resourceslots[i]] +
                " = " +
                data[resourceslots[i]]
            );
            */
            if (
              DBSchedule[resourceslots[i]] === "free" &&
              data[resourceslots[i]] === "free"
            ) {
              /* do nothing - ok */
            }
            if (
              DBSchedule[resourceslots[i]] === "free" &&
              data[resourceslots[i]] !== "free"
            ) {
              /* do nothing - ok */
            }
            if (
              DBSchedule[resourceslots[i]] !== "free" &&
              data[resourceslots[i]] !== "free"
            ) {
              if (DBSchedule[resourceslots[i]] === data[resourceslots[i]]) {
                /* do nothing - ok */
              } else {
                Conflict.push(resourceslots[i]);
              }
            }
            // // console.log("Conflict = " + Conflict.toString());
          }
          if (Conflict.length === 0) {
            Document.set(data, { merge: true })
              .then(() => {
                resolve({
                  result: "success",
                  message: "Document Updated",
                  id: Document.id
                });
              })
              .catch(error => {
                reject(error);
              });
          } else {
            resolve({
              result: "failure",
              message: "Conflicts Detected",
              conflicts: Conflict
            });
          }
        } else {
          // Document Not Found
          Document.set(data, { merge: true })
            .then(() => {
              resolve({
                result: "success",
                message: "Document Updated",
                id: Document.id
              });
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    });
  },

  GetDocumentByID: function(collection, id) {
    return new Promise(resolve => {
      let Document = firebase.db.collection(collection).doc(id);
      let Data = {};
      Document.get()
        .then(function(doc) {
          if (doc.exists) {
            Data = doc.data();
            Data.id = doc.id;
            resolve({
              result: "success",
              message: "Document Found",
              data: Data
            });
          } else {
            resolve({
              result: "failure",
              message: "Document Not Found"
            });
          }
        })
        .catch(function(error) {
          resolve({
            result: "error",
            message: error
          });
        });
    });
  },
  // Read Documents
  readPortals: function(collection) {
    return new Promise(resolve => {
      let Documents = firebase.db.collection(collection);
      let Data = [];
      Documents.get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            var Document = {};
            Document = doc.data();
            Document.id = doc.id;
            Data.push(Document);
          });
          // // console.log("Data length = " + Data.length);
          resolve({
            result: "success",
            message: "Found " + Data.length + " Documents",
            data: Data
          });
        })
        .catch(function(error) {
          // console.log("Error getting documents: ", error);
          resolve(error);
        });
    });
  },
  GetSponsorClipsByGameID: function(
    collection,
    portalID,
    sponsorID,
    gameID,
    userID
  ) {
    return new Promise(resolve => {
      let Documents = firebase.db.collection(collection);
      // Filter Documents for a specific userID - Not Mandatory
      if (userID !== null && userID !== undefined) {
        Documents.where("userID", "==", userID);
      }
      let Data = [];
      if (
        portalID !== undefined &&
        sponsorID !== undefined &&
        gameID !== undefined
      ) {
        // Filter Documents for the specific portal using portalID
        Documents.where("portalID", "array-contains", portalID)
          .where("sponsorID", "==", sponsorID)
          .where("gameID", "==", gameID)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              var Document = {};
              Document = doc.data();
              Document.id = doc.id;
              Data.push(Document);
            });
            resolve({
              result: "success",
              message: "Found " + Data.length + " Documents",
              data: Data
            });
          })
          .catch(function(error) {
            // console.log("Error getting documents: ", error);
            resolve(error);
          });
      } else {
        resolve({
          result: "failure",
          message: "Missing portalID/sponsorID/gameID",
          data: Data
        });
      }
    });
  },
  GetClipsByGameID: function(collection, portalID, gameID, userID) {
    return new Promise(resolve => {
      let Documents = firebase.db.collection(collection);
      // Filter Documents for a specific userID - Not Mandatory
      if (userID !== null && userID !== undefined) {
        Documents.where("userID", "==", userID);
      }
      let Data = [];
      if (portalID !== undefined && gameID !== undefined) {
        // Filter Documents for the specific portal using portalID
        Documents.where("portalID", "array-contains", portalID)
          .where("gameID", "==", gameID)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              var Document = {};
              Document = doc.data();
              Document.id = doc.id;
              Data.push(Document);
            });
            resolve({
              result: "success",
              message: "Found " + Data.length + " Documents",
              data: Data
            });
          })
          .catch(function(error) {
            // console.log("Error getting documents: ", error);
            resolve(error);
          });
      } else {
        resolve({
          result: "failure",
          message: "Missing portalID/sponsorID/gameID",
          data: Data
        });
      }
    });
  },
  GetClipsByStatusAndGameID: function(
    collection,
    portalID,
    gameID,
    status,
    userID
  ) {
    return new Promise(resolve => {
      let Documents = firebase.db.collection(collection);
      // Filter Documents for a specific userID - Not Mandatory
      if (userID !== null && userID !== undefined) {
        Documents.where("userID", "==", userID);
      }
      let Data = [];
      if (portalID !== undefined && gameID !== undefined) {
        // Filter Documents for the specific portal using portalID
        Documents.where("portalID", "array-contains", portalID)
          .where("gameID", "==", gameID)
          .where("status", "==", status)
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              var Document = {};
              Document = doc.data();
              Document.id = doc.id;
              Data.push(Document);
            });
            resolve({
              result: "success",
              message: "Found " + Data.length + " Documents",
              data: Data
            });
          })
          .catch(function(error) {
            // console.log("Error getting documents: ", error);
            resolve(error);
          });
      } else {
        resolve({
          result: "failure",
          message: "Missing portalID/status/gameID",
          data: Data
        });
      }
    });
  }
};
